import React, { useState, useEffect, useRef } from "react"
import {
  Button,
  FormControl,
  Modal,
  Table,
  Form,
  Row,
  Col,
} from "react-bootstrap"
import API from "components/Apis/API"

export const ScheduledPickupInput = ({ scheduledPickup, updateLength }) => {
  const inputWidth = "2.5rem"
  const labelStyle = {
    lineHeight: ".9rem",
    fontSize: ".8rem",
    color: "#B0B0B0",
  }
  const [month, setMonth] = useState("")
  const [day, setDay] = useState("")
  const [hour, setHour] = useState("")
  const [minute, setMinute] = useState("")
  const inputRefs = [useRef(), useRef(), useRef(), useRef()]

  const focusNextInput = (currentIndex) => {
    const nextIndex = currentIndex + 1
    if (nextIndex < inputRefs.length) {
      inputRefs[nextIndex].current.focus()
    }
  }

  const handleChange = (value, field, index) => {
    if (field === "month") {
      setMonth(value)
      if (value.length === 2 && value >= 1 && value <= 12) {
        focusNextInput(index)
      }
    } else if (field === "day") {
      setDay(value)
      if (value.length === 2 && value >= 1 && value <= 31) {
        focusNextInput(index)
      }
    } else if (field === "hour") {
      setHour(value)
      if (value.length === 2 && value >= 0 && value <= 23) {
        focusNextInput(index)
      }
    } else if (field === "minute") {
      setMinute(value)
    }
  }

  const clearDates = () => {
    setMonth("")
    setDay("")
    setHour("")
    setMinute("")
  }

  const formatDateTime = (month, day, hour, minute) => {
    if (!isNaN(month) && !isNaN(day) && !isNaN(hour)) {
      const currentYear = new Date().getFullYear()
      const formattedMonth = Number(month).toString().padStart(2, "0")
      const formattedDay = Number(day).toString().padStart(2, "0")
      const formattedHour = Number(hour).toString().padStart(2, "0")
      const formattedMinute = Number(minute).toString().padStart(2, "0")
      const formattedDateTime = `${currentYear}-${formattedMonth}-${formattedDay}T${formattedHour}:${formattedMinute}`
      return formattedDateTime
    } else {
      return ""
    }
  }

  const handleScheduleChange = () => {
    const formattedDateTime = formatDateTime(month, day, hour, minute)
    const e = {
      target: {
        name: "scheduled_pickup",
        value: formattedDateTime,
      },
    }

    updateLength(e)
  }

  useEffect(() => {
    const initialDate = scheduledPickup || ""
    const getDateValues = (
      initialDate,
      setMonth,
      setDay,
      setHour,
      setMinute
    ) => {
      const dateObject = new Date(initialDate)
      const formatValue = (value) => value.toString().padStart(2, "0")
      setMonth(formatValue(dateObject.getMonth() + 1))
      setDay(formatValue(dateObject.getDate()))
      setHour(formatValue(dateObject.getHours()))
      setMinute("00")
    }
    if (initialDate) {
      getDateValues(initialDate, setMonth, setDay, setHour, setMinute)
    }
  }, [])

  useEffect(() => {
    handleScheduleChange()
  }, [month, day, hour, minute])

  return (
    <td style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <div style={labelStyle} className='label'>
          Month
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControl
            ref={inputRefs[0]}
            type='number'
            className='modalInput pl-1 pr-0'
            value={month}
            onChange={(e) => handleChange(e.target.value, "month", 0)}
            min='1'
            max='12'
            maxLength='2'
            style={{ width: inputWidth }}
          />
          <span>-</span>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <div style={labelStyle} className='label ml-1'>
          Day
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControl
            ref={inputRefs[1]}
            type='number'
            className='modalInput pl-1 pr-0'
            value={day}
            onChange={(e) => handleChange(e.target.value, "day", 1)}
            min='1'
            max='31'
            maxLength='2'
            style={{ width: inputWidth }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <div style={labelStyle} className='label ml-1'>
          Hour
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControl
            ref={inputRefs[2]}
            type='number'
            className='modalInput ml-1 pl-1 pr-0'
            value={hour}
            onChange={(e) => handleChange(e.target.value, "hour", 2)}
            min='0'
            max='23'
            maxLength='2'
            style={{ width: inputWidth }}
          />
          <span>:</span>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <div style={labelStyle} className='label'>
          Minute
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControl
            ref={inputRefs[3]}
            type='number'
            className='modalInput pl-1 pr-0'
            value={minute}
            onChange={(e) => handleChange(e.target.value, "minute", 3)}
            min='0'
            max='30'
            step='30'
            maxLength='2'
            style={{ width: inputWidth }}
          />
        </div>
      </div>
      <Button
        variant='secondary'
        size='sm'
        type='button'
        className='mt-3'
        onClick={() => {
          clearDates()
          inputRefs[0].current.focus()
        }}
      >
        Clear
      </Button>
    </td>
  )
}

export const checkOldSkidCount = (row) => {
  if (row.units_old) {
    return <i style={{ color: "red" }} className='fa fa-exclamation' />
  } else {
    return ""
  }
}

export const countCrossingandDocs = (
  data,
  setLoadsCrossing,
  setMxDocsReady
) => {
  const countVerticalLine = (string) => {
    return string.split("|").length - 1
  }
  let crossings = 0
  let docsReady = 0
  data.forEach((item, i) => {
    if (item.mx_status_ref === "Crossing") {
      crossings += 1
    }
    if (countVerticalLine(item.mx_documents_ref) === 2) {
      docsReady += 1
    }
  })
  setLoadsCrossing(crossings)
  setMxDocsReady(docsReady)
}

export const countHidden = (data, setHidden) => {
  let hidden = 0
  data.forEach((item, i) => {
    if (item.hidden == 1) {
      hidden += 1
    }
  })

  setHidden(hidden)
}

export const countOrdersAtRisk = (data, setOrdersAtRistk) => {
  let count = 0
  data.forEach((item, i) => {
    const scheduledPickup = new Date(item.scheduled_pickup)
    const dropDead = new Date(item.drop_dead)
    if (item.terminal === "4" || item.terminal === "5") {
      dropDead.setHours(dropDead.getHours() + 1)
    }
    if (scheduledPickup && dropDead < scheduledPickup) {
      count += 1
    }
  })
  setOrdersAtRistk(count)
}

export const AtRiskModel = ({ showModal, setShowModal, terminal }) => {
  const [orders, setOrders] = useState([])

  const handleClose = () => {
    setShowModal(false)
  }

  const fetchData = async () => {
    const url = "admin/get_customer_informed"
    const response = await API.postData(url, { terminal })
    setOrders(response.data)
    if (!response.status) {
      console.log(response.msg)
    }
  }

  const updateNotification = async (i, e) => {
    const orderID = orders[i].ORDER_ID
    const checked = e.target.checked
    const url = "admin/update_customer_informed"
    const response = await API.postData(url, { orderID, checked })
    if (!response.status) {
      console.log(response.msg)
    }
  }

  const updateNotificationNotes = async (i) => {
    const orderID = orders[i].ORDER_ID
    const notes = orders[i].notes
    const url = "admin/notes_customer_informed"
    const response = await API.postData(url, { orderID, notes })
    if (!response.status) {
      console.log(response.msg)
    }
  }

  useEffect(() => {
    if (showModal) {
      fetchData()
    }
  }, [terminal, showModal])

  return (
    <Modal show={showModal}>
      <Modal.Header>
        <Modal.Title className='mt-0'>Orders At Risk</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {orders.map((order, i) => (
          <React.Fragment key={i}>
            {i > 0 && <hr />}
            <Row className='mb-2'>
              <Col xs={3}>
                <strong>Pro: </strong>
                {order.order_no} {order.order_group}
              </Col>
              <Col xs={3}>
                <strong>Team: </strong>
                {order.service_team}
              </Col>
              <Col xs={3}>
                <strong>Notified: </strong>
                <input
                  type='checkbox'
                  checked={order.notified}
                  onChange={(e) => {
                    const updatedOrders = [...orders]
                    updatedOrders[i] = {
                      ...order,
                      notified: e.target.checked,
                    }
                    setOrders(updatedOrders)
                    updateNotification(i, e)
                  }}
                />{" "}
              </Col>
              <Col xs={3}>
                <strong>Notified By: </strong>
                {order.username}
              </Col>
            </Row>
            <Row className='mb-5'>
              <Col xs={8}>
                <input
                  type='text'
                  className='w-100'
                  placeholder='notes'
                  value={order.notes}
                  onChange={(e) => {
                    const updatedOrders = [...orders]
                    updatedOrders[i] = { ...order, notes: e.target.value }
                    setOrders(updatedOrders)
                  }}
                  onBlur={() => updateNotificationNotes(i)}
                />
              </Col>
              <Col>
                <strong>Last Notification: </strong> {order.last_update}
              </Col>
            </Row>
          </React.Fragment>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export function isOrderABusByNamingConvention(order) {
  let busNomenclaturePatterns;

  const bus = order.bus;
  const terminal = order.terminal;

  // Determine patterns based on the terminal
  switch (String(terminal)) {
    case "1": // "LRD NBB"
      busNomenclaturePatterns = [/L(\d)/, /L(MON|TUE|WED|THU|FRI|SAT|SUN)/, /LP(\d)/];
      break;
    case "2": // "CKV SBB"
      busNomenclaturePatterns = [/CS(\d)/, /CS(MON|TUE|WED|THU|FRI|SAT|SUN)/, /CSP(\d)/];
      break;
    case "3": // "CKV NBB"
      busNomenclaturePatterns = [/CN(\d)/, /CN(MON|TUE|WED|THU|FRI|SAT|SUN)/, /CNP(\d)/];
      break;
    case "5": // "DTW SBB"
      busNomenclaturePatterns = [/DS(\d)/, /DS(MON|TUE|WED|THU|FRI|SAT|SUN)/, /DSP(\d)/];
      break;
    // add cases for any new terminals here
    default: // Default return all orders for any other id provided
      return null;
  }
  if (bus) {
    // Check if the bus matches any of the patterns
    for (const pattern of busNomenclaturePatterns) {
      const match = bus.match(pattern);
      if (match) {
        return match[1].toLowerCase(); // Return the captured value (digit or day)
      }
    }
  }

  return null; // No match found
}

export function isBusABusByNamingConvention(bus) {
  let busNomenclaturePatterns;

  const busName = bus.name;
  const terminal = bus.terminal;

  // Determine patterns based on the terminal
  switch (String(terminal)) {
    case "1": // "LRD NBB"
      busNomenclaturePatterns = [/L(\d)/, /L(MON|TUE|WED|THU|FRI|SAT|SUN)/, /LP(\d)/];
      break;
    case "2": // "CKV SBB"
      busNomenclaturePatterns = [/CS(\d)/, /CS(MON|TUE|WED|THU|FRI|SAT|SUN)/, /CSP(\d)/];
      break;
    case "3": // "CKV NBB"
      busNomenclaturePatterns = [/CN(\d)/, /CN(MON|TUE|WED|THU|FRI|SAT|SUN)/, /CNP(\d)/];
      break;
    case "5": // "DTW SBB"
      busNomenclaturePatterns = [/DS(\d)/, /DS(MON|TUE|WED|THU|FRI|SAT|SUN)/, /DSP(\d)/];
      break;
    // add cases for any new terminals here
    default: // Default return all orders for any other id provided
      return null;
  }
  if (busName) {
    // Check if the bus matches any of the patterns
    for (const pattern of busNomenclaturePatterns) {
      const match = busName.match(pattern);
      if (match) {
        return match[1].toLowerCase(); // Return the captured value (digit or day)
      }
    }
  }

  return null; // No match found
}

export function isPartialABusByNamingConvention(partial) {
  let busNomenclaturePatterns;

  const bus = partial.bus?.name;
  const terminal = partial.order?.terminal;
  // Determine patterns based on the terminal
  switch (String(terminal)) {
    case "1": // "LRD NBB"
      busNomenclaturePatterns = [/L(\d)/, /L(MON|TUE|WED|THU|FRI|SAT|SUN)/, /LP(\d)/];
      break;
    case "2": // "CKV SBB"
      busNomenclaturePatterns = [/CS(\d)/, /CS(MON|TUE|WED|THU|FRI|SAT|SUN)/, /CSP(\d)/];
      break;
    case "3": // "CKV NBB"
      busNomenclaturePatterns = [/CN(\d)/, /CN(MON|TUE|WED|THU|FRI|SAT|SUN)/, /CNP(\d)/];
      break;
    case "5": // "DTW SBB"
      busNomenclaturePatterns = [/DS(\d)/, /DS(MON|TUE|WED|THU|FRI|SAT|SUN)/, /DSP(\d)/];
      break;
    // add cases for any new terminals here
    default: // Default return all orders for any other id provided
      return null;
  }
  if (bus) {
    // Check if the bus matches any of the patterns
    for (const pattern of busNomenclaturePatterns) {
      const match = bus.match(pattern);
      if (match) {
        return match[1].toLowerCase(); // Return the captured value (digit or day)
      }
    }
  }

  return null; // No match found
}
// Synchronous hash function (FNV-1a)
function fnv1aHash(str) {
  let hash = 0x811c9dc5; // FNV-1a offset basis
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash *= 0x01000193; // FNV-1a prime
  }
  return hash >>> 0; // Ensure it’s a positive integer (32-bit unsigned)
}

// Convert to color (HSL format)
export function stringToColor(str) {
  // 1. Create a consistent hash of the string using the FNV-1a hash function
  const hashValue = fnv1aHash(str);

  // 2. Convert the hash to HSL values
  const hue = Math.abs(hashValue % 360); // Ensure 0-359 degree range

  // 3. Get dynamic saturation and lightness from the hash
  const saturation = (hashValue % 60) + 35;  // Randomize saturation (range: 40% - 99%)
  const lightness = (hashValue % 30) + 50;  // Randomize lightness (range: 50% - 79%)

  // 4. Return the color in HSL format
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}